import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useDevLogging } from "@limitless/common/hooks/dev-logging/DevLoggingContext";
import { useMFAVerify } from "./MFAVerifyHook";
const MFASetupContext = /*#__PURE__*/createContext({});
export const MFASetupContextProvider = ({
  children
}) => {
  const {
    stateTracker
  } = useDevLogging();
  const state = useMFAVerify();
  const mfaStateContext = useMemo(() => {
    stateTracker.trackState({
      state
    });
    return {
      ...state
    };
  }, [state.verifyMFAState, state.mfaCtx]);
  return /*#__PURE__*/React.createElement(MFASetupContext.Provider, {
    value: mfaStateContext
  }, children);
};
export const useMFASetupContext = () => {
  return useContext(MFASetupContext);
};
MFASetupContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};